// chunkview question types
const QUESTION_TYPES = {
  TEXT_MATCH: 't',
  FREE_TEXT: 'f',
  MULTI_ANSWER_MULTI_CHOICE: 'm',
  SINGLE_ANSWER_MULTI_CHOICE: 's',
  INTEGER: 'i',
  NO_RESPONSE: 'n',
};

// question types for question sets and exams
const EXAM_QUESTION_TYPES = {
  COMPLEX: 'c',
  DRAG_AND_DROP: 'drag_and_drop',
  FILL_IN_BLANK: 'fill_in_blank',
  ILLUSTRATION: 'illustration',
  NUMBER_ON_IMAGE: 'number_on_image',
  NUMBER: 'number',
  PARENT: 'p',
  SELECT_MULTI: 'select_multi_answer',
  SIMPLE_MATH: 'simple_math',
  SINGLE_ANSWER_MULTI_CHOICE: 's',
  TEXT_CHECKLIST: 'l',
  TEXT: 't',
  UNKNOWN: '?',
  WORKED_ANNOTATED_IMAGE: 'a',
  WORKED: 'w',
};

export const questionTypeDisplayNames = {
  [EXAM_QUESTION_TYPES.DRAG_AND_DROP]: 'Drag and drop', // 'drag_and_drop'
  [EXAM_QUESTION_TYPES.ILLUSTRATION]: 'Drawing', // 'illustration'
  [EXAM_QUESTION_TYPES.SIMPLE_MATH]: 'Equation input', // aka Simple Math ('simple_math')
  [EXAM_QUESTION_TYPES.FILL_IN_BLANK]: 'Fill in the blank', // 'fill_in_blank'

  [EXAM_QUESTION_TYPES.SELECT_MULTI]: 'Multiple Choice', // aka Multi Answer Multiple Choice ('select_multi_answer')
  [EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE]: 'Multiple Choice', // aka Single Answer Multiple Choice ('s')

  [EXAM_QUESTION_TYPES.NUMBER_ON_IMAGE]: 'Number input', // aka Number on Image ('number_on_image')
  [EXAM_QUESTION_TYPES.NUMBER]: 'Number input', // aka Number ('number')

  [EXAM_QUESTION_TYPES.TEXT_CHECKLIST]: 'Short Answer', // aka Short Answer with Checklist ('l')
  [EXAM_QUESTION_TYPES.TEXT]: 'Short Answer', // aka Short Answer ('t')

  // The following question types are deemed 'not compatible with Tasks' (i.e. Task Setting)
  // See: https://docs.google.com/spreadsheets/d/1ChFSKm16HbnqjOWzuC-g7ZrR-T64y3kW0ShnZdVHyZM/edit?gid=0#gid=0
  [EXAM_QUESTION_TYPES.WORKED_ANNOTATED_IMAGE]: 'Annotated Image',
  [EXAM_QUESTION_TYPES.WORKED]: 'Worked',
  [EXAM_QUESTION_TYPES.COMPLEX]: 'Complex Solution', // aka Complex Solution ('c')
  [EXAM_QUESTION_TYPES.PARENT]: 'Parent',
  [EXAM_QUESTION_TYPES.UNKNOWN]: 'Unknown',
};

const EXAM_QUESTION_INPUT_TYPES = {
  NUMBER: 'NUMBER',
  TEXT: 'TEXT',
  SIMPLE_MATH: 'SIMPLE_MATH',
  DRAWING: 'DRAWING',
  CATEGORIZATION: 'CATEGORIZATION',
};

const EXAM_QUESTION_OPTION_TYPES = {
  DROPPABLE: 'DROPPABLE',
  STRING_MATCH: 'STRING_MATCH',
};

const EXAM_QUESTION_TYPE_FIELD_INPUT_TYPE_MAPPINGS = {
  [EXAM_QUESTION_TYPES.NUMBER]: EXAM_QUESTION_INPUT_TYPES.NUMBER,
  [EXAM_QUESTION_TYPES.SIMPLE_MATH]: EXAM_QUESTION_INPUT_TYPES.SIMPLE_MATH,
  [EXAM_QUESTION_TYPES.NUMBER_ON_IMAGE]: EXAM_QUESTION_INPUT_TYPES.NUMBER,
  [EXAM_QUESTION_TYPES.FILL_IN_BLANK]: EXAM_QUESTION_INPUT_TYPES.TEXT,
  [EXAM_QUESTION_TYPES.DRAG_AND_DROP]: EXAM_QUESTION_INPUT_TYPES.CATEGORIZATION,
  [EXAM_QUESTION_TYPES.ILLUSTRATION]: EXAM_QUESTION_INPUT_TYPES.DRAWING,
};

const CORRECTABLE_EXAM_QUESTION_TYPES = [
  EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE,
  EXAM_QUESTION_TYPES.SELECT_MULTI,
  EXAM_QUESTION_TYPES.TEXT,
  EXAM_QUESTION_TYPES.COMPLEX,
  EXAM_QUESTION_TYPES.NUMBER,
  EXAM_QUESTION_TYPES.SIMPLE_MATH,
  EXAM_QUESTION_TYPES.NUMBER_ON_IMAGE,
  EXAM_QUESTION_TYPES.DRAG_AND_DROP,
];

export {
  QUESTION_TYPES,
  EXAM_QUESTION_TYPES,
  EXAM_QUESTION_INPUT_TYPES,
  EXAM_QUESTION_OPTION_TYPES,
  EXAM_QUESTION_TYPE_FIELD_INPUT_TYPE_MAPPINGS,
  CORRECTABLE_EXAM_QUESTION_TYPES,
};
